import { CommonModule } from "@angular/common";
import { Component, input, output } from "@angular/core";

import { I18nPipe } from "@bitwarden/ui-common";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "bv-listing-pagination",
  templateUrl: "bv-listing-pagination.component.html",
  imports: [CommonModule, I18nPipe],
})
export class BvListingPaginationComponent {
  readonly currentPage = input.required<number>();
  readonly pageSize = input.required<number>();
  readonly totalCount = input.required<number>();
  readonly pageSizeOptions = input<number[]>([10, 25, 50]);

  readonly pageChange = output<number>();
  readonly pageSizeChange = output<number>();

  protected get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalCount() / this.pageSize()));
  }

  protected get paginationPages(): (number | "ellipsis")[] {
    const total = this.totalPages;
    const currentPage = this.currentPage();

    if (total <= 5) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    const pages = new Set<number>([1, total, currentPage]);
    if (currentPage > 1) {
      pages.add(currentPage - 1);
    }
    if (currentPage < total) {
      pages.add(currentPage + 1);
    }

    const sorted = [...pages].sort((a, b) => a - b);
    const result: (number | "ellipsis")[] = [];

    sorted.forEach((page, index) => {
      const previous = sorted[index - 1];
      if (previous != null && page - previous > 1) {
        result.push("ellipsis");
      }
      result.push(page);
    });

    return result;
  }

  protected onPageSizeChange(rawValue: string): void {
    const size = Number.parseInt(rawValue, 10);
    if (!Number.isFinite(size) || size <= 0) {
      return;
    }

    this.pageSizeChange.emit(size);
  }
}
